export default __webpack_public_path__ + "static/media/gyroY.0cc27b10.svg";